export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all-supplyTab": [
    {
      title: "Config Supply Chain",
      cls: "bulk-supply-tab-active",
      icon: "sliders",
      disabled:true
    }
  ],
  "all": [
    {
      title: "Activate/Deactivate",
      cls: "bulk-activate-rule",
      icon: "toggle-off",
      disabled:false
    }
  ],
  "actions": [
    {
      title: "Edit",
      cls: "edit-location",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Activate/Deactivate",
      cls: "activate-rule",
      icon: "toggle-off",
      disabled:false
    }
  ],
  "supplyTab": [
    {
      title: "Config Supply Chain",
      cls: "supply-tab-active",
      icon: "sliders",
      disabled:false
    }
  ], 
  "splSupplyTab": [
    {
      title: "Config Supply Chain",
      cls: "supply-tab-active",
      icon: "sliders",
      disabled:true
    }
  ], 

};


// WEBPACK FOOTER //
// ./src/pages/facilities/filter/actionOptions.js